import { Breadcrumb, IBreadcrumbProps } from "@fluentui/react";
import * as React from "react";

export const CustomBreadcrumb = ({
  ariaLabel,
  dividerAs,
  focusZoneProps,
  items,
  maxDisplayedItems,
  onRenderItem,
  onRenderOverflowIcon,
  overflowAriaLabel,
  styles
}: IBreadcrumbProps) => (
  <Breadcrumb
    ariaLabel={ariaLabel ?? "Breadcrumb with items rendered as buttons"}
    dividerAs={dividerAs}
    focusZoneProps={focusZoneProps}
    items={items}
    maxDisplayedItems={maxDisplayedItems}
    onRenderItem={onRenderItem}
    onRenderOverflowIcon={onRenderOverflowIcon}
    overflowAriaLabel={overflowAriaLabel ?? "More links"}
    styles={styles}
  />
);
